import { Drawer } from "antd";
import SubjectDetails from "./PolicySubjectDetails";
import SubjectDetailsProvider from "./PolicySubjectDetailsContext";
import styled from "styled-components";
import dekra from "../../../../../../../../style/dekra";
import { useTranslation } from "react-i18next";

const PolicySubjectDetailsFullScreenWrapper = styled.div`
  // margin-top: 5px;
  width: 100%;
  min-height: calc(100vh - 115px);

  .ant-tabs-nav-operations {
    display: none !important;
  }

  display: flex;

  .ant-tabs {
    width: 100%;
  }

  .ant-tabs-nav-wrap {
    background-color: #fff;
    box-shadow: 0 0 5px #aaa;
  }
    
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }

  .ant-tabs-ink-bar {
    background: ${dekra.primaryColor};
    display: none;
  }

  .ant-tabs-nav {
    margin-bottom: 0;

    &:before {
      border: none;
    }
  }

  .ant-tabs-nav-list {
    background-color: #eee;
    color: #333;

    .ant-tabs-tab:first-child {
      border-left: none;
    }
  }

  .ant-tabs-tab {
    padding: 0.75em 2em;
    letter-spacing: 1px;
    border-left: 1px solid #ccc;
    text-transform: uppercase;
    font-size: 0.9em !important;

    .ant-tabs-tab-btn {
      &:hover {
        color: ${dekra.primaryColor};
      }
    }
  }

  .ant-tabs-tab-active {
    background: ${dekra.primaryColor};
    position: relative;

    .ant-tabs-tab-btn {
      color: white;

      &:hover {
        color: white;
      }
    }
  }
`;

interface IPolicySubjectDetailsFullScreenProps {
  selectedSubjectId: number | undefined;
  onClose: () => void;
}

const PolicySubjectDetailsFullScreen = ({
  selectedSubjectId,
  onClose,
}: IPolicySubjectDetailsFullScreenProps) => {
  const { t } = useTranslation();
  
  return (
    <Drawer
      closable={true}
      open={selectedSubjectId !== undefined}
      width="100VW"
      onClose={onClose}
      destroyOnClose={true}
      title= {t("TITLE.policy-subject-details")}
    >
      {selectedSubjectId && (
        <PolicySubjectDetailsFullScreenWrapper>
          <SubjectDetailsProvider idSubject={selectedSubjectId}>
            <SubjectDetails />
          </SubjectDetailsProvider>
        </PolicySubjectDetailsFullScreenWrapper>
      )}
    </Drawer>
  );
};

export default PolicySubjectDetailsFullScreen;
